import { salesmanProjectListKeywordFilter } from "actions";
import {
  SALESMAN_PARENTSALESMAN_FILTER,
  SALESMAN_SALESAREA_FILTER,
  SALESMAN_SALESMANCODE_FILTER,
  SALESMAN_VISITPLAN_FILTER,
  SALESMAN_VISITPLAN_STATUS_FILTER,
  SALESMAN_DISPLAY_FILTER,
  SALESMAN_PRODUCT_DISPLAY_FILTER,
  SALESMAN_TEAM_DISPLAY_FILTER,
  SALESMAN_SEARCH_TRIGGER,
  SALESMAN_PROJECTGROUP_FILTER,
  SALESMAN_PROJECTTYPE_FILTER,
  SALESMAN_PROJECTCATEGORY_FILTER,
  SALESMAN_PROJECTLINE_FILTER,
  SALESMAN_PROJECT_STATUS_FILTER,
  SALESMAN_PROJECT_LIST_KEYWORD_FILTER,
  SALESMAN_PROJECT_STAGE_FILTER,
  ROUTE_NO_FILTER,
} from "../constants/ActionTypes";

let bm = new Date();
bm.setMonth(bm.getMonth() - 3);
let intYear = bm.getFullYear();
let intMonth = bm.getMonth() + 1;
let defaultStartDate = `${intYear}-${intMonth}-01`;

const initialState = {
  parentSalesmanSelected: "",
  salesAreaSelected: "",
  salesmanCodeSelected: "",
  startDateSelected: defaultStartDate,
  statusSelected: [
    { label: "กำลังดำเนินการ", value: 0 },
    { label: "รออนุมัติ", value: 1 },
    { label: "อนุมัติ", value: 2 },
    { label: "แจ้งแก้ไข", value: 4 },
  ],
  salesmanDisplaySelected: "",
  salesmanProductDisplaySelected: "",
  salesmanTeamDisplaySelected: "",
  salesmanProjectGroupSelected: "",
  salesmanProjectTypeSelected: "",
  salesmanProjectCategorySelected: "",
  salesmanProjectLineSelected: "",
  salesmanProjectStatusSelected: "",
  salesmanProjectListKeyword: "",
  saleStageSelected: "",
  searchTrigger: 1  // เริ่มต้นที่ 1 เพื่อดึงข้อมูลครั้งแรก
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SALESMAN_PARENTSALESMAN_FILTER:
      return {
        ...state,
        parentSalesmanSelected: action.payload,
      };
    case SALESMAN_SALESAREA_FILTER:
      return {
        ...state,
        salesAreaSelected: action.payload,
      };
    case SALESMAN_SALESMANCODE_FILTER:
      return {
        ...state,
        salesmanCodeSelected: action.payload,
      };
    case ROUTE_NO_FILTER:
      return {
        ...state,
        routeNoSelected: action.payload,
      };
    case SALESMAN_VISITPLAN_FILTER:
      return {
        ...state,
        startDateSelected: action.payload,
      };
    case SALESMAN_VISITPLAN_STATUS_FILTER:
      return {
        ...state,
        statusSelected: action.payload,
      };
    case SALESMAN_DISPLAY_FILTER:
      return {
        ...state,
        salesmanDisplaySelected: action.payload,
      };
    case SALESMAN_PRODUCT_DISPLAY_FILTER:
      return {
        ...state,
        salesmanProductDisplaySelected: action.payload,
      };
    case SALESMAN_TEAM_DISPLAY_FILTER:
      return {
        ...state,
        salesmanTeamDisplaySelected: action.payload,
      };
    case SALESMAN_PROJECTGROUP_FILTER:
      return {
        ...state,
        salesmanProjectGroupSelected: action.payload,
      };
    case SALESMAN_PROJECTTYPE_FILTER:
      return {
        ...state,
        salesmanProjectTypeSelected: action.payload,
      };
    case SALESMAN_PROJECTCATEGORY_FILTER:
      return {
        ...state,
        salesmanProjectCategorySelected: action.payload,
      };
    case SALESMAN_PROJECTLINE_FILTER:
      return {
        ...state,
        salesmanProjectLineSelected: action.payload,
      };
    case SALESMAN_PROJECT_STATUS_FILTER:
      return {
        ...state,
        salesmanProjectStatusSelected: action.payload,
      };

    case SALESMAN_PROJECT_LIST_KEYWORD_FILTER:
      return {
        ...state,
        salesmanProjectListKeyword: action.payload,
      };

    case SALESMAN_PROJECT_STAGE_FILTER:
      return {
        ...state,
        saleStageSelected: action.payload,
      };
    case SALESMAN_SEARCH_TRIGGER:
      return {
        ...state,
        searchTrigger: action.payload,
      };
    default:
      return state;
  }
};
